import InfoIcon from '@mui/icons-material/Info';
import QIconButton from 'components/QIconButton';
import QTip from 'components/QuickenControls/QTip';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  infoIcon: {
    color: theme.palette.icon.disabled,
    padding: '0 0 0 0 !important',
    backgroundColor: 'inherit !important',
  },
}));

const InfoTooltipIcon = (props) => {
  const {
    tooltipText,
    tooltipPlacement,
    className,
    size,
    tooltipClass,
    tooltipHTML,
    arrowClass,
    icon,
    slotProps,
    ...otherProps
  } = props;
  const { classes, cx } = useStyles();
  return (
    <QTip
      solidTheme
      tooltipClass={tooltipClass}
      arrowClass={arrowClass}
      placement={tooltipPlacement}
      position={tooltipPlacement}
      title={tooltipText}
      html={tooltipHTML}
      noTippyTip
      arrow
      enableOnMobile
      {...slotProps?.qtip}
    >
      <QIconButton
        size={size}
        disableFocusRipple
        IconComponent={icon || InfoIcon}
        className={cx(classes.infoIcon, className)}
        sharedcomponentid='InfoTooltipIcon'
        {...otherProps}
      />
    </QTip>
  );
};

InfoTooltipIcon.propTypes = {
  slotProps: PropTypes.object,
  id: PropTypes.string,
  icon: PropTypes.any,
  tooltipText: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  tooltipClass: PropTypes.string,
  tooltipHTML: PropTypes.object,
  arrowClass: PropTypes.string,
};

export default InfoTooltipIcon;
